export default __webpack_public_path__ + "static/media/brown-tick.4b47c11f.svg";